import {newShop} from '@nuskin/ns-shop';

newShop.CouponItem = function(couponItem) {
    'use strict';

    this.campaignId = couponItem.campaignId;
    this.code = couponItem.code;
    this.desc = couponItem.desc;
    this.minimumPurchasePrice = isNaN(parseInt(couponItem.minimumPurchasePrice)) ? '' : parseInt(couponItem.minimumPurchasePrice);
    this.discountAmount = isNaN(parseInt(couponItem.discountAmount)) ? '' : parseInt(couponItem.discountAmount);
    this.expiration = couponItem.expiration !== undefined ? new Date(couponItem.expiration).toLocaleDateString(): '';
    this.orderTypeAvailability = couponItem.orderTypeAvailability;
    this.webDesc = couponItem.webDesc;
};

export default newShop.CouponItem;
